import withHonorarios from "../../hoc/withTrabajadores/withHonorarios";
import Honorarios from "../../view/components/RegistroUsuarios/Honorarios/VistaHonorarios";

export default withHonorarios(Honorarios);